<template>
  <div class="main">
    <img src="../../assets/images/exit-btn.png" class="stb-close" @click="handleStbClose">
    <div class="content">
      <div>
        <div class="music-knowledge-detail-slide">
          <div class="slide-icon" style="font-size: 32px;" @click="changeFontSize(1)">A</div>
          <div class="slide">
            <el-slider
              :show-tooltip="false"
              v-model="fontSizeStep"
              :step="1"
              :min="-3"
              :max="7"
              vertical
              height="200px"
              show-stops
            />
          </div>
          <div class="slide-icon" style="font-size: 24px;" @click="changeFontSize(-1)">A</div>
        </div>
      </div>
      <div class="ql-editor-self" :class="'h5-class-' + fontSizeStep" v-html="html"></div>
    </div>

  </div>
</template>

<script>
import { queryEbookInfo } from '@/services'

export default {
  name: 'EBook',
  data () {
    return {
      id: 0,
      fontSizeStep: 0,
      data: {},
      html: ''
    }
  },
  created () {
    document.body.style.overflow = 'hidden'
    this.id = this.$route.params.id
    this.token = this.$route.query.token
    this.pilotAuth = this.$route.query.official !== '1' ? 1 : 0
    this.server = this.$route.query.deviceType === 'stb' ? 'device' : 'platform'
    this.getData()
  },
  methods: {
    // 机顶盒关闭
    handleStbClose () {
      try {
        window.jsInterface.jsCallAndroid2Finish()
      } catch {
        this.$alert('无法触发 Bridge 失败')
      }
    },
    async getData () {
      const { data } = await queryEbookInfo({ id: this.id, __isPilotAuth: this.pilotAuth }, this.token, this.server)
      this.data = data
      this.html = data.content
    },
    changeFontSize (k) {
      if ((this.fontSizeStep === 7 && k > 0) || (this.fontSizeStep === -3 && k < 0)) {
        return
      }
      this.fontSizeStep += k
    }
  }
}
</script>

<style scoped lang="scss">
.main {
  background: url("~@/assets/images/ebook-bg.jpg") no-repeat center center;
  background-size:cover;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  min-width: 1280px;
  min-height: 720px;
  .ql-editor-self{
    white-space: pre-wrap;
    tab-size: 4;
  }

  .stb-close {
    position: fixed;
    bottom: 50px;
    right: 50px;
    z-index: 100;
  }
  .content {
    height: 940px;
    //min-height: 700px;
    //background: #fefcd9;
    width: 1450px;
    overflow-y: auto;
    margin: 80px 30px 80px 235px;
    padding-right: 205px;
  }
  ::-webkit-scrollbar{
    width:8px;
    background-color:#eae4c3;
    height:100px;
    border-radius: 4px;
  }
  ::-webkit-scrollbar-thumb{
    box-shadow:rgba(240,240,240,.5);
    background-color:#ba9061;
    -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
    border-radius: 6px;
  }
  .music-knowledge-detail-slide /deep/  {
    transform:scale(1.5);
    position: absolute;
    right: 60px;
    width: 40px;
    top: 150px;
    .slide-icon {
      width: 38px;
      height: 38px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #b15f27;
      font-weight: 500;
    }
    .el-slider__stop {
      background-color: #ffc75a;
    }
    .el-slider__runway {
      background-color: white;
    }
  }
  .image-span {
    background: none;
  }

  @for $i from -3 through 7 {
    .h5-class-#{$i} /deep/ {
      .ql-align-center {
        text-align: center;
      }
      h1{
        font-size: 56px + 3 * $i;
        font-weight: bold;
        color: #b05d23;
        line-height: 71px + 3 * $i;
        margin:0;
      }
      h2{
        font-size: 46px + 3 * $i;
        font-weight: bold;
        color: #b05d23;
        line-height: 61px + 3 * $i;
        margin:0;
      }
      p{
        font-size: 38px + 3 * $i;
        color: #78543a;
        line-height: 53px + 3 * $i;
        margin:0;
      }
      ol{
        padding-left: 38px + 3 * $i;
      }
      li{
        font-size: 38px + 3 * $i;
        color: #78543a;
        line-height: 53px + 3 * $i;
        margin:0;
      }
      audio {
        transform: scale(1.8);
        margin: 0 130px 0 130px;
        padding-top: 10px;
        padding-bottom: 10px;
      }
      audio::-webkit-media-controls-panel{
        background:#ebd4ab;
      }
      audio::-webkit-media-controls-mute-button {
        display: none;
      }
      video::-internal-media-controls-overflow-button {
        display:none;
      }
      video::-webkit-media-controls-enclosure {
        overflow:hidden;
      }
      video::-webkit-media-controls-panel {
        width: calc(100% + 50px);
      }
    }
  }
}

</style>
